<app-header
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>

<div class="container page-container">
  @if (hasReport()) {
    <div class="report-content-scroll">
      <div class="report-shell">
        <div class="report-header section-card">
          <img src="/imgs/icon.png" alt="MyMindLog icon">
          <div class="meta">
            <span>{{ reportMeta()?.reportName }}</span>
            <span>{{ reportMeta()?.patientName }}</span>
            <span>
              {{ $safeNavigationMigration(reportMeta()?.startDate) | date:'dd/MM/yyyy' }} - {{ $safeNavigationMigration(reportMeta()?.endDate) | date:'dd/MM/yyyy' }}
            </span>
          </div>
        </div>

        <div class="section-title">{{ 'appointments-report.appointments' | translate }}</div>
        <div class="report-body section-card">
          @if (reportLines().length > 0) {
            <table class="appointments-table">
              <colgroup>
                <col class="date-col">
                <col class="currency-col">
                <col class="amount-col">
              </colgroup>
              <thead>
                <tr>
                  <th class="date-col">{{ 'appointments-report.date_time' | translate }}</th>
                  <th class="currency-col">{{ 'appointments-report.currency' | translate }}</th>
                  <th class="amount">{{ 'appointments-report.amount' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (line of reportLines(); track line.appointmentDate + line.currency + line.value) {
                  <tr>
                    <td class="date-col">
                      <div class="date-time-cell">
                        <span>{{ line.appointmentDate | date:'dd/MM/yyyy' }}</span>
                        <span>{{ line.appointmentDate | date:'HH:mm' }}</span>
                      </div>
                    </td>
                    <td class="currency-col">{{ line.currency }}</td>
                    <td class="amount">{{ getCurrencySymbol(line.currency) }} {{ line.value | number:'1.2-2' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <div class="line-empty">{{ 'appointments-report.empty' | translate }}</div>
          }
        </div>

        <div class="report-summary section-card">
          <div class="summary-title">{{ 'appointments-report.total_per_currency' | translate }}</div>
          <div class="summary-item summary-muted">
            <span>{{ 'appointments-report.total_sessions' | translate }}</span>
            <span>{{ totalSessions() }}</span>
          </div>
          @for (item of reportTotals(); track item.currency) {
            <div class="summary-item">
              <span>{{ item.currency }}</span>
              <span>{{ getCurrencySymbol(item.currency) }} {{ item.total | number:'1.2-2' }}</span>
            </div>
          }
        </div>

        @if (hasComments()) {
          <div class="section-title">{{ 'appointments-report.comments' | translate }}</div>
          <div class="report-comments section-card">
            <div class="comments-text">{{ reportMeta()?.comments }}</div>
          </div>
        }

        <div class="report-footer">
          <span class="footer-title">{{ 'appointments-report.generated_by' | translate }}</span>
          <span>
            {{ reportMeta()?.psychologistName }}
            @if(reportMeta()?.psychologistLicenseNumber || reportMeta()?.psychologistLicenseCountry){
              - {{ reportMeta()?.psychologistLicenseNumber }} {{ reportMeta()?.psychologistLicenseCountry }}
            }
          </span>
          <span>{{ reportMeta()?.psychologistEmail }}</span>
          <span>{{ $safeNavigationMigration(reportMeta()?.generatedAt) | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>
    </div>

    <div class="actions-container">
      <app-button
        [buttonLabel]="'appointments-report.download_pdf' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED"
        [buttonDisabled]="loadingPdfAction()"
        (click)="downloadPdf()">
      </app-button>

      <app-button
        [buttonLabel]="'appointments-report.share_pdf' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR"
        [buttonDisabled]="loadingPdfAction()"
        (click)="sharePdf()">
      </app-button>
    </div>
  }
</div>

@if (loadingPdfAction()) {
  <div class="loading-overlay">
    <app-loading></app-loading>
  </div>
}
